export default function validateInfo(values) {
  let errors = {};

  // Full Name validation
  if (!values.fullname || !values.fullname.trim()) {
    errors.fullname = 'Full name is required';
  } else if (values.fullname.trim().length < 2) {
    errors.fullname = 'Full name must be at least 2 characters';
  } else if (values.fullname.trim().length > 100) {
    errors.fullname = 'Full name must be less than 100 characters';
  } else if (!/^[a-zA-Z\s'-]+$/.test(values.fullname.trim())) {
    errors.fullname = 'Full name can only contain letters, spaces, hyphens, and apostrophes';
  }

  // Email validation
  if (!values.email || !values.email.trim()) {
    errors.email = 'Email address is required';
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email.trim())) {
    errors.email = 'Please enter a valid email address';
  } else if (values.email.trim().length > 254) {
    errors.email = 'Email address is too long';
  }

  // GitHub Username validation
  if (!values.github || !values.github.trim()) {
    errors.github = 'GitHub username is required';
  } else {
    const githubUsername = values.github.trim();
    // Remove GitHub URL if provided and extract username
    const usernameMatch = githubUsername.match(/(?:https?:\/\/)?(?:www\.)?github\.com\/([a-zA-Z0-9](?:[a-zA-Z0-9]|-(?=[a-zA-Z0-9])){0,38})\/?$/) || 
                         githubUsername.match(/^([a-zA-Z0-9](?:[a-zA-Z0-9]|-(?=[a-zA-Z0-9])){0,38})$/);
    
    if (!usernameMatch) {
      errors.github = 'Please enter a valid GitHub username or URL';
    } else if (usernameMatch[1].length < 1) {
      errors.github = 'GitHub username is too short';
    } else if (usernameMatch[1].length > 39) {
      errors.github = 'GitHub username is too long';
    }
  }

  return errors;
}